export default __webpack_public_path__ + "static/media/italygot-screenshot-05.5ebf94de.png";